<template>
  <div class="content" ref="tableBox" id="tableBox">
    <el-tabs
      class="tabLv3"
      type="border-card"
      v-model="tabName"
      :style="{ position: 'static' }"
    >
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>批量打点
        </span>
        <div class="w_normalNav">
          <button
            v-if="ShowNextLevelBtn"
            @click="addOpsUser"
            class="nextButton"
          >
            增加下级区域
          </button>
          <!-- <button v-if="ShowNextLevelBtn1" @click="configUser" class="nextButton">配置该安装点用户</button> -->
          <button
            v-show="!bShowNextLevelBtn"
            @click="cancel"
            class="cancelButton"
          >
            返回
          </button>
          <button v-show="isDelete" @click="remove" plain class="cancelButton">
            删除
          </button>
          <button v-if="isConfirm" @click="otherconfirm" class="confirmButton">
            确定
          </button>
          <!-- <button class="BlueSmBtn" @click="otherconfirm">确定</button> -->
          <button v-if="isEdit" @click="edit" class="confirmButton">
            修改
          </button>
        </div>
        <!-- 中间间隔栏 -->
        <!-- <div class="interval"></div> -->
        <!-- v-if="hasPermission('opsuser:tree')" -->
        <!-- 底部详细表格 -->
        <div class="detailtab">
          <div class="w_region">
            <!-- <div class="filter" ref="filter">
              <el-input placeholder="区域搜索" suffix-icon="el-icon-search"></el-input>
            </div>-->
            <div class="t" ref="t">
              <el-tree
                :data="treeData"
                @node-click="handleNodeClick"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :default-expanded-keys="expandRegion"
                :props="defaultProps"
                node-key="label"
                ref="tree"
              >
                <!-- <span class="custom-tree-node" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>-->
              </el-tree>
            </div>
          </div>

          <div class="treeDetail" v-show="showForm">
            <div class="formtab" v-loading="loading">
              <el-form
                label-position="right"
                label-width="120px"
                :model="formLabelAlign"
                ref="ruleForm"
                :rules="rules"
              >
                <div class="row-message">
                  <span>基本信息：</span>
                </div>
                <el-row type="flex" class="row-bg">
                  <el-col>
                    <el-form-item label="名称" prop="name">
                      <el-input v-model="formLabelAlign.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="类型" prop="type">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.type"
                        clearable
                        placeholder="请选择"
                        @change="selectAZD"
                      >
                        <el-option
                          v-for="item in type"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="ifSave">
                    <el-form-item label="重点危险源" prop="danger">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.danger"
                      >
                        <el-option
                          v-for="item in Dangers1"
                          :key="item.id"
                          :value="item.id"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="ifDanger">
                    <el-form-item label="重点危险源" prop="danger">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.danger"
                      >
                        <el-option
                          v-for="item in Dangers2"
                          :key="item.id"
                          :value="item.id"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div class="row-message">
                  <span>位置信息：</span>
                </div>
                <el-row type="flex" class="row-bg">
                  <el-col>
                    <el-form-item label="地址" prop="address">
                      <el-input
                        v-if="showMap"
                        v-model="formLabelAlign.address"
                        @input="fMap"
                      ></el-input>
                      <el-input
                        v-if="showPicture"
                        v-model="formLabelAlign.address"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="showMap">
                    <el-form-item label="经度" prop="longitude">
                      <el-input
                        v-model="formLabelAlign.longitude"
                        v-loading="!formLabelAlign.longitude"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="showMap">
                    <el-form-item label="纬度" prop="latitude">
                      <el-input
                        v-model="formLabelAlign.latitude"
                        v-loading="!formLabelAlign.latitude"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="showPicture">
                    <el-form-item label="横坐标" prop="a">
                      <el-input v-model="formLabelAlign.a">{{
                        this.abscissa
                      }}</el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="showPicture">
                    <el-form-item label="纵坐标" prop="b">
                      <el-input v-model="formLabelAlign.b">{{
                        this.ordinate
                      }}</el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div
                  id="region-baidu-map"
                  v-show="this.showStatus === 0 ? true : false"
                  style="width: 90%; height: 500px; margin: 0 auto"
                ></div>
                <div
                  class="buildChose"
                  v-show="this.showStatus === 1 ? true : false"
                  style="width: 100%; height: 500px"
                >
                  <building
                    v-if="showBuild"
                    ref="pictureChioce"
                    @getResult1="getResult1"
                    @getDot="getDot"
                    @getArea="getArea"
                    :picture1="picture1"
                    :updatenext="updatenext"
                  ></building>
                  <displays
                    v-if="showDis"
                    :areaIds="oPreRemove_data.id"
                    :imgUrl="this.imgUrl1"
                    :titleName="this.titleName"
                  ></displays>
                </div>

                <div class="row-message">
                  <span>展示信息：</span>
                </div>
                <el-row type="flex" class="row-bg">
                  <el-col :span="12" v-if="showMap">
                    <el-form-item label="展示方式" prop="model">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.model"
                        placeholder="请选择"
                        @change="selectMod"
                      >
                        <el-option
                          v-for="item in model1"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="showPicture">
                    <el-form-item label="展示方式" prop="model">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.model"
                        clearable
                        placeholder="请选择"
                        @change="selectMod"
                      >
                        <el-option
                          v-for="item in model2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="this.formLabelAlign.model == 1">
                    <el-form-item label="平面图" prop="plane">
                      <el-select
                        :popper-append-to-body="false"
                        v-model="formLabelAlign.plane"
                        clearable
                        placeholder="请选择"
                        @change="selectPicture"
                      >
                        <el-option
                          v-for="item in Planes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div
                  class="buildChose"
                  v-show="this.formLabelAlign.model === 1 ? true : false"
                  style="width: 100%; height: 500px"
                >
                  <building
                    ref="buildChioce"
                    @getResult2="getResult2"
                    v-if="showBuild2"
                    :tupian="tupian"
                    :upload="upload"
                  ></building>
                  <!-- Url修改  displayb  149行 -->
                  <displays
                    v-if="showDis"
                    :imgUrl="this.imgUrl2"
                    :upload="upload"
                  ></displays>
                </div>

                <!-- 蜂鸟图 -->
                <el-row
                  v-if="this.formLabelAlign.model === 2"
                  type="flex"
                  class="row-bg"
                >
                  <el-col>
                    <el-form-item label="地图编号" prop="mapNumber">
                      <el-input v-model="formLabelAlign.mapNumber"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="楼层编号" prop="floorNumber">
                      <el-input v-model="formLabelAlign.floorNumber"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="点位编号" prop="dotNumber">
                      <el-input v-model="formLabelAlign.dotNumber"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <!-- treeDetail -->
          <div
            class="treeDetail"
            v-show="!showForm"
            style="
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #b5b5b5;
            "
          >
            请点击左侧菜单！
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Qs from "qs";
import { mapCenter, mapInit, geocoder, diyInfoWindow } from "./map.js";
export default {
  components: {
    building: () => import("../../../../../public/builds/choice"),
    displays: () => import("../../../../../public/builds/displayb"),
  },
  data() {
    return {
      //默认展开节点数组
      expandRegion: [1],
      //横纵坐标
      abscissa: "",
      ordinate: "",
      //baseMsg
      baseA: "",
      baseB: "",
      baseMsg: [],
      upload: 1,
      updatenext: 1,
      id: "",
      imgUrl1: "",
      imgUrl2: "",
      titleName: "",
      tupian: "",
      picture1: "",
      showDis: false,
      showBuild: false,
      showBuild2: false,
      showStatus: "",
      // regionId:"",
      tabName: "jsgl",
      treeData: [],
      showForm: false,
      id: 0,
      isAddArea: false,
      formLabelAlign: {
        plane: "",
        name: "",
        address: "",
        model: "",
        level: "",
        parentId: "",
        type: "",
        longitude: "",
        groupId: "",
        latitude: "",
        danger: "",
        a: "",
        b: "",
        mapNumber: "",
        floorNumber: "",
        dotNumber: "",
      },
      //preRemove预删除
      oPreRemove_node: {},
      oPreRemove_data: {},
      bShowNextLevelBtn: true,
      ShowNextLevelBtn: false,
      ShowNextLevelBtn1: false,
      loading: true,
      ifSave: true,
      ifDanger: false,
      showMap: true,
      showPicture: false,
      showFather: false,
      useFather: false,
      //确认按钮
      isConfirm: false,
      //修改按钮
      isEdit: false,
      //删除按钮
      isDelete: false,
      //安装点判断
      type: [
        {
          value: 1,
          label: "安装点",
        },
        {
          value: 0,
          label: "非安装点",
        },
      ],
      //地图、平面图
      model1: [
        {
          value: "",
          label: "请选择",
        },
        {
          value: 1,
          label: "平面图",
        },
        {
          value: 0,
          label: "地图",
        },
        {
          value: 2,
          label: "蜂鸟图",
        },
      ],
      model2: [
        {
          value: 1,
          label: "平面图",
        },
        {
          value: 2,
          label: "蜂鸟图",
        },
      ],
      Planes: [
        {
          value: 0,
          label: "使用上级图片",
        },
        {
          value: 1,
          label: "新上传图片",
        },
      ],
      // 弹出框必填项
      rules: {
        name: [
          {
            required: true,
            message: "请输入区域名",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        longitude: [
          {
            required: true,
            message: "请输入经度",
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            message: "请输入纬度",
            trigger: "blur",
          },
        ],
        a: [
          {
            required: true,
            message: "请输入横坐标",
            trigger: "blur",
          },
        ],
        b: [
          {
            required: true,
            message: "请输入纵坐标",
            trigger: "blur",
          },
        ],
        model: [
          {
            required: true,
            message: "请选择展示方式",
            trigger: "change",
          },
        ],
      },
      defaultProps: {
        children: "areas",
        label: "name",
      },
      //是否重点危险源
      Dangers1: [
        { id: 1, label: "是" },
        { id: 0, label: "否" },
      ],
      Dangers2: [{ id: 1, label: "是" }],
      //百度地图
      oMap: {},
    };
  },
  created() {
    this.getTree();
  },
  mounted() {
    mapInit.call(this, ({ lng, lat, name, address }) => {
      this.$set(this.formLabelAlign, "longitude", lng > 0 ? lng : 0);
      this.$set(this.formLabelAlign, "latitude", lat > 0 ? lat : 0);
      this.$set(this.formLabelAlign, "name", name);
      this.$set(this.formLabelAlign, "address", address.split("地址：")[1]);
    });
  },
  methods: {
    //修改
    edit() {
      this.$router.push({
        name: "editRegion",
        query: { baseMsg: this.baseMsg, baseA: this.baseA, baseB: this.baseB },
      });
    },
    //监听平面图
    selectPicture(value) {
      if (value === 0) {
        //使用上级图片
        this.useFather = false;
        this.showBuild2 = false;
      } else {
        this.useFather = false;
        this.showBuild2 = true;
      }
    },
    //使用上级图片
    useFatherPicture() {
      this.showBuild2 = true;
      this.$axiosget(
        "operation/area/info?" +
          Qs.stringify({
            id: this.id,
          })
      ).then((res) => {
        //console.log(this.$refs.buildChioce);
        this.tupian = res.data.data.url;
        this.$refs.buildChioce.gettupian(this.tupian);
      });
    },

    // 打点工具
    getDot(val) {
      var params = new FormData();
      params.append("phone0", localStorage.getItem("phone"));
      params.append("name", val);
      params.append("address", val);
      params.append("model", 1);
      params.append("longitude", this.formLabelAlign.longitude);
      params.append("latitude", this.formLabelAlign.latitude);
      params.append("a", this.formLabelAlign.a);
      params.append("b", this.formLabelAlign.b);
      params.append("mapNumber", this.formLabelAlign.mapNumber);
      params.append("floorNumber", this.formLabelAlign.floorNumber);
      params.append("dotNumber", this.formLabelAlign.dotNumber);
      params.append("danger", this.formLabelAlign.danger);
      params.append("level", this.formLabelAlign.level);
      params.append("type", this.formLabelAlign.type);
      params.append("parentId", this.formLabelAlign.parentId);
      params.append("url", this.picture1);

      this.$axiospost("zuul/operation/area/add", params).then((res) => {
        if (res.data.status === "10000") {
          this.$message.success("添加成功");
          this.regionId = res.data.data;

          this.vall1.result.map((i) => {
            i.area_id = this.regionId;
          });
          //console.log(this.vall1.result);
          this.$axiospost(
            "operation/area/saveAreaParamater",
            this.vall1.result
          ).then((res) => {
            this.loading = false;
          });
        }
      });
    },
    //确认按钮
    otherconfirm() {
      var params = new FormData();
      params.append("phone0", localStorage.getItem("phone"));
      params.append("name", this.formLabelAlign.name);
      params.append("address", this.formLabelAlign.address);
      params.append("model", this.formLabelAlign.model);
      params.append("longitude", this.formLabelAlign.longitude);
      params.append("latitude", this.formLabelAlign.latitude);
      params.append("a", this.formLabelAlign.a);
      params.append("b", this.formLabelAlign.b);
      params.append("mapNumber", this.formLabelAlign.mapNumber);
      params.append("floorNumber", this.formLabelAlign.floorNumber);
      params.append("dotNumber", this.formLabelAlign.dotNumber);
      params.append("danger", this.formLabelAlign.danger);
      params.append("level", this.formLabelAlign.level);
      params.append("type", this.formLabelAlign.type);
      params.append("parentId", this.formLabelAlign.parentId);
      params.append("url", this.picture1);

      //console.log(this.vall2, "vall2");
      if (this.formLabelAlign.model === 1 && this.formLabelAlign.plane === 1) {
        if (!this.vall2) {
          this.$notify({
            title: "请保存图片后再确认",
            type: "warning",
          });
          return;
        } else {
          if (!this.vall2.file) {
            this.$notify({
              title: "请选择并保存图片后再确认",
              type: "warning",
            });
            return;
          } else {
            params.append("file", this.vall2.file);
          }
        }
      }

      // 判断isAddArea如果为true时增加表单信息
      if (this.isAddArea == true) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$axiospost("zuul/operation/area/add", params).then((res) => {
              if (res.data.status === "10000") {
                this.$message.success("添加成功");
                // this.formLabelAlign = {
                //   name: "",
                //   address: "",
                //   model: "",
                //   level: "",
                //   parentId: "",
                //   type: "",
                //   longitude: " ",
                //   groupId: "",
                //   latitude: " ",
                //   a: " ",
                //   b: " ",
                //   danger: ""
                // };
                this.regionId = res.data.data;
                this.getTree();

                this.vall1.result.map((i) => {
                  i.area_id = this.regionId;
                });
                //console.log(this.vall1.result);
                this.$axiospost(
                  "operation/area/saveAreaParamater",
                  this.vall1.result
                ).then((res) => {
                  this.loading = false;
                });
              }
            });
          } else {
            return false;
          }
        });

        // 判断isAddArea为false时修改表单信息
      } else {
        params.append("id", this.id);
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$axiospost("/zuul/operation/area/update", params).then(
              (res) => {
                if (res.data.data == 3) {
                  this.$message.success("区域关联了设备不能修改安装点");
                }
                if (res.data.data == 2) {
                  this.$message.success("区域有下级区域不能修改安装点");
                }
                if (res.data.data == 1) {
                  this.$message.success("修改成功");
                  this.ShowNextLevelBtn = false;
                  this.getTree();
                }
              }
            );
          } else {
            return false;
          }
        });
      }
    },
    filterNode(value, data, node) {
      return value.some((id) => id == data.id);
    },
    getTree() {
      let user = JSON.parse(localStorage.getItem("user"));
      // this.$axiospost("operation/permission/findPermission", {
      //   id: user.id,
      //   isAdmin: user.isAdmin,
      //   status: user.status,
      //   phone: user.phone,
      //   name:user.name
      // }).then(res => {})
      this.$axiosget("operation/area/queryAll?ignoreCache=true").then((res) => {
        this.treeData = res.data.data;
        //console.log(this.treeData, "treeData");
      });
      if (this.treeData) {
        this.$axiosget("operation/area/findAreaByUserId").then((res) => {
          // this.$nextTick(() => this.$refs.tree.filter(res.data.data));
          this.$refs.tree.filter(res.data.data);
        });
      }
      // let p1 = this.$axiosget("operation/area/queryAll?ignoreCache=true");
      // let p2 = this.$axiosget("operation/area/findAreaByUserId");
      // Promise.all([p1, p2]).then(res => {
      //   this.treeData = res[0].data.data;
      //   //console.log(this.treeData, "data");
      //   this.$nextTick(() => this.$refs.tree.filter(res[1].data.data));
      // });
    },

    handleNodeClick(data, node, self = {}) {
      if (data.id === null) {
        this.showForm = false;
        return;
      }
      if (this.$refs["ruleForm"]) this.$refs["ruleForm"].clearValidate();
      this.id = data.id;
      var that = this;
      that.isConfirm = false;
      that.isEdit = true;
      that.showFather = false;
      that.useFather = false;
      that.showDis = false;
      that.loading = true;
      this.baseA = "";
      this.baseB = "";
      this.$axiosget(
        "operation/area/info?" +
          Qs.stringify({
            id: data.id,
          })
      ).then((res) => {
        that.showDis = true;
        that.showBuild = false;
        that.showBuild2 = false;
        that.showForm = true;
        that.isAddArea = false;
        that.id = data.id;
        that.model = data.model;
        that.danger = data.danger;
        that.imgUrl1 = res.data.data.parentUrl;
        that.titleName = res.data.data.name ? res.data.data.name : "未知";
        if (res.data.data.url === null) {
          that.imgUrl2 = res.data.data.parentUrl;
        } else {
          that.imgUrl2 = res.data.data.url;
        }
        //that.onlyPic = data;
        let {
          name,
          address,
          model,
          level,
          parentId,
          type,
          groupId,
          // a,
          // b,
          danger,
          floorNumber,
          dotNumber,
          mapNumber,
        } = res.data.data;
        that.formLabelAlign = {
          name,
          address,
          model,
          level,
          parentId,
          type,
          groupId,
          // a,
          // b,
          danger,
          floorNumber,
          dotNumber,
          mapNumber,
        };
        //横纵坐标

        this.baseMsg = res.data.data;
        if (res.data.data.areaParameter != null) {
          that.formLabelAlign.a = res.data.data.areaParameter.leftCenter;
          that.formLabelAlign.b = res.data.data.areaParameter.topCenter;
          this.baseA = that.formLabelAlign.a;
          this.baseB = that.formLabelAlign.b;
        }
        //判断父节点的model
        if (
          res.data.data.parentUrl === "null" ||
          res.data.data.parentUrl === null ||
          res.data.data.parentUrl === ""
        ) {
          that.showMap = true;
          that.showPicture = false;
          that.showStatus = 0;
        } else {
          that.showMap = false;
          that.showPicture = true;
          that.showStatus = 1;
        }

        if (that.formLabelAlign.type == 1) {
          that.ShowNextLevelBtn = false;
          that.ShowNextLevelBtn1 = true;
        } else {
          that.ShowNextLevelBtn = true;
          that.ShowNextLevelBtn1 = false;
        }

        if (that.formLabelAlign.address == null) {
          that.formLabelAlign.address = "";
        }

        that.fPreRemove(data, node);
        that.fMap(address);
        that.bShowNextLevelBtn = true;
        that.isDelete = true;
        that.loading = false;
      });
    },
    addOpsUser(level, parentId) {
      this.loading = false;
      this.isAddArea = true;
      this.isConfirm = true;
      this.isEdit = false;
      this.showForm = true;
      this.showBuild = true;
      this.showBuild2 = true;
      this.showDis = false;
      this.formLabelAlign.type = 0;
      this.formLabelAlign.plane = 1;
      this.formLabelAlign.model = "";
      if (this.model === 0) {
        this.showMap = true;
        this.showPicture = false;
        this.showStatus = 0;
      } else {
        this.showMap = false;
        this.showPicture = true;
        this.showFather = true;
        this.showStatus = 1;
      }
      if (this.danger === 0) {
        this.ifSave = true;
        this.ifDanger = false;
      } else {
        this.ifDanger = true;
        this.ifSave = false;
      }
      this.formLabelAlign.name = this.formLabelAlign.address = "";
      this.formLabelAlign.latitude = this.formLabelAlign.longitude = " ";
      this.formLabelAlign.a = this.formLabelAlign.b = " ";
      this.formLabelAlign.level = isNaN(level)
        ? this.oPreRemove_data.level + 1
        : level;
      this.formLabelAlign.parentId = isNaN(parentId) ? this.id : parentId;
      this.bShowNextLevelBtn = false;
      this.isDelete = false;
      this.ShowNextLevelBtn = false;
      this.ShowNextLevelBtn1 = false;

      this.$axiosget(
        "operation/area/info?" +
          Qs.stringify({
            id: this.formLabelAlign.parentId,
          })
      ).then((res) => {
        this.picture1 = res.data.data.url;
        this.$refs.pictureChioce.getpicture1(this.picture1);
      });
    },
    fPreRemove(data, node) {
      this.oPreRemove_data = data;
      this.oPreRemove_node = node;
    },
    remove() {
      const parent = this.oPreRemove_node.parent;
      const children = parent.data.areas || parent.data;
      const index = children.findIndex((d) => d.id === this.oPreRemove_data.id);
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axiosdelete(
            "operation/area/delete?" +
              Qs.stringify({
                id: this.oPreRemove_data.id,
                parentId: this.oPreRemove_data.parentId,
              })
          )
            .then((res) => {
              if (res.data.data == 3) {
                this.$message.success("区域关联了设备不能删除");
              }

              if (res.data.data == 2) {
                this.$message.success("区域有下级区域不能删除");
              }
              if (res.data.data == 1) {
                this.$message.success("删除成功");
                children.splice(index, 1);
                this.showForm = false;
                this.isEdit = false;
                this.isDelete = false;
                this.ShowNextLevelBtn = false;
              }
            })
            .catch((error) => {
              if (this.$route.path == "/login") {
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {});
    },
    //安装点
    selectAZD(type) {
      this.formLabelAlign.type = type;
    },
    //模型
    selectMod(model) {
      this.formLabelAlign.model = model;
    },
    configUser() {
      this.$router.push({
        path: `/systemConfiguration/allSystemConfiguration/system/allSystem/system/concatUser/${this.formLabelAlign.groupId}/安装点用户`,
      });
    },
    cancel() {
      this.handleNodeClick(this.oPreRemove_data, this.oPreRemove_node);
    },

    getResult1(val) {
      //console.log(val);
      this.vall1 = val;
      this.$set(this.formLabelAlign, "a", val.result[0].leftCenter);
      this.$set(this.formLabelAlign, "b", val.result[0].topCenter);
      // this.formLabelAlign.a = val.result[0].leftCenter;
      // this.formLabelAlign.b = val.result[0].topCenter;
      this.abscissa = val.result[0].leftCenter;
      this.ordinate = val.result[0].topCenter;
      // this.confirm();
    },
    getArea(value) {
      this.$set(this.formLabelAlign, "name", value);
      this.$set(this.formLabelAlign, "address", value);
      this.otherconfirm();
    },
    getResult2(val) {
      this.vall2 = val;
    },
    // 修改信息
    confirm() {
      // var params = new FormData();
      // params.append("phone0", localStorage.getItem("phone"));
      // params.append("name", this.formLabelAlign.name);
      // params.append("address", this.formLabelAlign.address);
      // params.append("model", this.formLabelAlign.model);
      // params.append("longitude", this.formLabelAlign.longitude);
      // params.append("latitude", this.formLabelAlign.latitude);
      // params.append("level", this.formLabelAlign.level);
      // params.append("type", this.formLabelAlign.type);
      // params.append("parentId", this.formLabelAlign.parentId);
      // params.append("file", this.vall.file);
      // // 判断isAddArea如果为true时增加表单信息
      // if (this.isAddArea == true) {
      //   this.$refs.ruleForm.validate(valid => {
      //     if (valid) {
      //       this.$axiospost("operation/area/add", params).then(res => {
      //         if (res.data.status === "10000") {
      //           this.$message.success("添加成功");
      //           this.loading = false;
      //           this.formLabelAlign = {
      //             name: "",
      //             address: "",
      //             model: "",
      //             level: "",
      //             parentId: "",
      //             type: "",
      //             longitude: " ",
      //             groupId: "",
      //             latitude: " "
      //           };
      //           this.regionId = res.data.data;
      //           this.getTree();
      //         }
      //       });
      //     } else {
      //       return false;
      //     }
      //   });
      //   // 判断isAddArea为false时修改表单信息
      // } else {
      //   params.append("id", this.id);
      //   this.$refs.ruleForm.validate(valid => {
      //     if (valid) {
      //       this.$axiospost("operation/area/update", params).then(res => {
      //         if (res.data.data == 3) {
      //           this.$message.success("区域关联了设备不能修改安装点");
      //         }
      //         if (res.data.data == 2) {
      //           this.$message.success("区域有下级区域不能修改安装点");
      //         }
      //         if (res.data.data == 1) {
      //           this.$message.success("修改成功");
      //           this.ShowNextLevelBtn = false;
      //           this.getTree();
      //         }
      //       });
      //     } else {
      //       return false;
      //     }
      //   });
      // }
    },
    // 删除当前信息
    handleDelete(row) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axiospost(
            "api/v1/deleteopsuser",
            Qs.stringify({
              id: row.id,
            })
          )
            .then((res) => {
              this.$message.success("删除成功");
            })
            .catch((error) => {
              if (this.$route.path == "/login") {
              } else {
                this.$message.error("删除失败");
              }
            });
        })
        .catch(() => {});
    },
    // 清空列表信息
    closeForm() {
      this.$refs.ruleForm.resetFields();
    },
    fMap(v) {
      mapCenter.call(this, v, ({ lng, lat, point }) => {
        this.$set(this.formLabelAlign, "longitude", lng > 0 ? lng : 0);
        this.$set(this.formLabelAlign, "latitude", lat > 0 ? lat : 0);
        diyInfoWindow.call(
          this,
          this.formLabelAlign.name,
          this.formLabelAlign.address,
          point
        );
      });
    },
  },
};
</script>

<style scope lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
  .nextButton {
    width: 123px;
    height: 33px;
    text-align: center;
    padding: 0;
    color: #cacaca;
    background: transparent;
    border: 1px solid #3d4963;
  }
}
.breadcrumb {
  margin-top: 0;
}
.interval {
  height: 10px;
  background-color: #edf0f5;
}
.detailtab {
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  .w_region {
    width: 260px;
    height: 800px;
    overflow: auto;
    background: #181c2e;
  }
  .w_region::-webkit-scrollbar {
    width: 0;
  }
  .treeDetail {
    background: #181c2e;
    width: 82%;
    // border: 1px solid #eeeeee;
    padding: 15px 15px 15px 0;
    margin-left: 15px;
    .formtab {
      margin-bottom: 20px;
      .row-message {
        height: 35px;
        width: 100%;
        margin-top: 10px;
        color: #cacaca;
        border-bottom: 1px solid #3d4963;
        span {
          display: inline-block;
          margin-left: 20px;
          padding-left: 10px;
          height: 35px;
          border-bottom: 2px solid #35b9f7;
        }
      }
      .row-button {
        height: 35px;
        .nextButton {
          width: 123px;
          height: 33px;
          text-align: center;
          padding: 0;
          color: #cacaca;
          background: transparent;
          border: 1px solid #3d4963;
          margin-left: 40px;
        }
      }
      .row-bg {
        margin-top: 20px;
        .el-col {
          width: 33%;
          .el-select-dropdown {
            background: #2e3657;
            border: 0 none;
          }
          .el-select-dropdown__item {
            color: #3587c7;
            font-size: 14px;
          }
          .el-select-dropdown__item.selected {
            color: #b5b5b5;
          }
          .el-select-dropdown__item.hover,
          .el-select-dropdown__item:hover {
            background: #262d4a;
          }
        }
      }
      .el-form-item {
        background: transparent;
        color: #cacaca;
        .el-form-item__label {
          color: #ccc;
        }
        .el-input {
          .el-input__inner {
            width: 280px;
            height: 35px;
            background: transparent;
            color: #cacaca;
            border: 1px solid #3d4963;
          }
        }
      }
      .buildChose {
        padding-right: 20px;
        .box {
          width: 100%;
        }
      }
      #painting {
        margin: 0 20px;
      }
    }
  }
}

.treeDetail .formtab {
  /*height: 340px;*/
  /*overflow: auto;*/
  padding: 0 10px 0 15px;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #4ea5ef;
  background: #4ea5ef;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #4ea5ef;
}
</style>
<style scope lang="less">
// .el-tree-node__content {
//   padding-top: 6px;
//   /*background: #e4edf9 !important;*/
// }
// .el-tree-node__content:hover {
//   background-color: #2e3657 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
//   background-color: #2e3657 !important;
// }

.w_region .el-tree {
  padding-top: 10px;
  background: transparent;
}

.w_region .el-tree-node:focus > .el-tree-node__content,
.w_region .el-tree-node__content:hover,
.w_region .el-tree > .el-tree-node > .el-tree-node__content,
.w_region .is-current {
  background: transparent;
}

.w_region .el-tree-node:focus > .el-tree-node__content .el-tree-node__label,
.w_region .el-tree-node__content:hover .el-tree-node__label,
.w_region
  .el-tree
  > .el-tree-node
  > .el-tree-node__content
  .el-tree-node__label,
.w_region .is-current > .el-tree-node__content .el-tree-node__label {
  background: #212740;
  transition: all 0.5s;
}

.w_region .el-tree-node__content {
  height: 42px;
}
.el-tree-node {
  position: relative;
}

.w_region
  .el-tree
  > .el-tree-node
  > .el-tree-node__content
  .el-tree-node__label {
  font-size: 16px;
  color: #fff;
  padding-left: 0;
  margin-left: 0;
  box-sizing: border-box;
}

.w_region
  .el-tree
  > .el-tree-node.is-expanded
  > .el-tree-node__content
  .el-tree-node__label {
  border-left: 3px solid #35b9f7;
}

.w_region
  .el-tree
  > .el-tree-node.is-expanded
  > .el-tree-node__content
  .is-leaf
  + .el-tree-node__label {
  border-left: 3px solid #212740;
}

.w_region .el-tree-node__content {
  display: block;
}

.w_region .el-tree-node__label {
  font-size: 14px;
  display: block;
  width: 100%;
  height: 42px;
  line-height: 42px;
  border-bottom: 1px solid #464958;
  color: #c3c3c3;
}

.w_region .noBorder .el-tree-node__label {
  border: 0 none;
}

.w_region .el-tree-node__expand-icon {
  transform: rotate(90deg);
  margin-left: 25px;
  margin-top: 9px;
  font-size: 14px;
  color: #fff;
  float: left;
  padding: 5px;
}

.w_region .el-tree-node__expand-icon.is-leaf {
  color: transparent;
}

.w_region .el-tree-node__expand-icon.is-leaf + .el-tree-node__label {
  padding-left: 18px;
  margin-left: -18px;
  box-sizing: content-box;
}

.w_region .el-tree-node__expand-icon.expanded {
  transform: rotate(-90deg);
}

.filter {
  padding: 16px 20px;
  // background: #253253;
  position: relative;
}

.filter .el-input__inner {
  width: 100%;
  height: 30px;
  border: 1px solid #3587c7;
  background: transparent;
  color: #ccc;
}

.filter .el-icon-search {
  color: #35b9f7;
}

.el-checkbox__inner:hover {
  border-color: #2e3657;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #4ea5ef;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4ea5ef;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ea5ef;
  border-color: #4ea5ef;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #4ea5ef;
  background: #4ea5ef;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #4ea5ef;
}
#addAreaBtn {
  width: 160px;
}
</style>

function newFunction() {
  return 1;
}



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/region copy/index.vue